import "./loan-sections.css";

const FLOAT_CARDS = [
  {
    icon: "fa-percent",
    label: "Low Interest Rates",
    position: "loan-float--top",
  },
  {
    icon: "fa-stopwatch",
    label: "Fast Approval",
    position: "loan-float--left",
  },
  {
    icon: "fa-file-lines",
    label: "Minimal Documentation",
    position: "loan-float--right",
  },
];

export default function LoanHero() {
  return (
    <section className="loan-hero">
      <div className="loan-hero-inner">
        <div className="loan-hero-copy">
          <p className="loan-eyebrow">LOANS MADE SIMPLE</p>
          <h1 className="loan-hero-title">
            Right Loan for Every Dream.
            <span> Fast, Flexible &amp; Hassle-Free.</span>
          </h1>
          <p className="loan-hero-lead">
            Get the right loan for your needs at competitive rates with quick
            approval and minimal documentation. We make borrowing simple and
            stress-free.
          </p>
          <a href="https://www.las.tatacapital.com/online/loans/las/apply-now-las-loan?sourceName=GPS_FINVEST_PRIVATE_LIMITED#!" target="blank" className="loan-hero-cta">
            Apply for Loan
            <span aria-hidden="true">&gt;</span>
          </a>
        </div>

        <div className="loan-hero-visual">
          <div className="loan-hero-blob loan-hero-blob--a" aria-hidden="true" />
          <div className="loan-hero-blob loan-hero-blob--b" aria-hidden="true" />
          <img
            src="/images/loan-hero-family.png"
            alt="Family with their dream home and car"
            className="loan-hero-img"
          />
          {FLOAT_CARDS.map((card) => (
            <div key={card.label} className={`loan-float ${card.position}`}>
              <span className="loan-float-icon" aria-hidden="true">
                <i className={`fa-solid ${card.icon}`} />
              </span>
              <span>{card.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
